<template>
  <div class="app-body_show container-fluid pt-4 pb-5">
    <div class="row">
      <div class="col-md-9">
        <!-- render error messages -->
        <static-messages v-if="error" :messages="error" :variant="`danger`" :containerClass="`mb-4`" @closed="error = null"/>
        <static-messages v-if="success" :messages="success" :variant="`success`" :containerClass="`mb-4`" @closed="success = null"/>

        <div class="card">
          <div v-if="isLoaded && isMemberLoaded" class="card-body py-1">
            <!-- member table -->
            <member :members="members"
              :researchGroup="researchGroup"
              :pendingMembers="pendingMembers"
              :isPendingMemberLoaded="isPendingMemberLoaded"
              @updateRole="updateRole"
              @updateContact="updateContact"
              @removeMember="removeMember"
            />
          </div>

          <div v-else class="card-body">
            <spinner :containerClass="`width--50px min-height--150px`" />
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <contact v-if="isLoaded && !$can.edit('research_group', researchGroup.rw_access)"
          :isLoaded="isLoaded"
          :item="researchGroup"
          :isPublic="canView"
          :scope="`research_group`">
        </contact>

        <!-- invite team member -->
        <invite-button-team v-if="isLoaded && $can.edit('research_group', researchGroup.rw_access)" :researchGroup="researchGroup"/>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import StaticMessages from '@/components/shared/StaticMessages'
import Contact from '@/components/contact/Show'
import Member from '@/components/shared/crud/Member'
import InviteButtonTeam from '@/components/invite/button/Team'

import ResearchGroupService from '@/services/research_group'

export default {
  name: 'researchGroupMembers',
  components: {
    StaticMessages,
    Spinner,
    Contact,
    Member,
    InviteButtonTeam
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    researchGroup: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      error: null,
      success: null,
      isRequest: false,
      isMemberLoaded: false,
      isPendingMemberLoaded: false,
      members: [],
      pendingMembers: []
    }
  },
  mounted () {
    if (this.isLoaded) this.fetch()

    this.$events.$on('research_group:permissions:updated', (members, user) => {
      this.members = members
      this.success = `Role for ${this.getFullName(user)} is successfully updated`
    })

    this.$events.$on('pusher:research_group-user-left', () => this.fetchMembers())
    this.$events.$on('pusher:research_group-contact-changed', () => this.fetchMembers())
    this.$events.$on('pusher:research_group-role-changed', () => this.fetchMembers())
  },
  computed: {
    canView () {
      return this.$can.view('research_group', this.researchGroup.rw_access)
    }
  },
  watch: {
    isLoaded (newVal, oldVal) {
      if (newVal !== oldVal && newVal && this.members.length <= 0) this.fetch()
    }
  },
  methods: {
    fetch () {
      this.fetchMembers()

      ResearchGroupService.getPendingMembers(this.researchGroup.slug_values[0]).then(members => {
        this.isPendingMemberLoaded = true
        this.pendingMembers = members
      }).catch(err => {
        this.error = this.handleError(err)
        this.isPendingMemberLoaded = !this.isEmpty(this.error)
      })
    },
    fetchMembers () {
      ResearchGroupService.getMembers(this.researchGroup.slug_values[0]).then(members => {
        this.members = members
        this.isMemberLoaded = true
      }).catch(err => {
        this.error = this.handleError(err)
        this.isMemberLoaded = !this.isEmpty(this.error)
      })
    },
    updateRole (member) {
      this.$events.$emit('modal:permissions:open', {}, this.researchGroup, member)
    },
    removeMember (member) {
      if (!this.isRequest) {
        this.isRequest = true
        ResearchGroupService.deleteMember(this.researchGroup.slug_values[0], member).then(() => {
          this.members.splice(this.members.findIndex((i) => {
            return this.hasMatchingSlug(i.slug_values, member.slug_values)
          }), 1)
          let users = this.researchGroup.users - 1
          this.$events.$emit('research_group:updated', 'users', users)

          // when removed self
          if (this.hasMatchingSlug(member.slug_values, this.$currentUser.slug_values)) {
            this.$events.$emit('research_group:updated', 'rw_access', 'public')
            this.$router.push({ name: 'research_group.show', params: { id: this.researchGroup.slug_values[0] } })
          } else {
            this.success = `Member ${this.getFullName(member)} is successfully removed`
          }

          this.isRequest = false
        }).catch(err => {
          this.isRequest = false
          this.error = this.handleError(err)
        })
      }
    },
    updateContact (member, value) {
      if (!this.isRequest) {
        this.isRequest = true
        ResearchGroupService.updateMember(this.researchGroup.slug_values[0], {
          slug: member.slug_values[0],
          contact: value
        }).then(updatedMembers => {
          let contacts = updatedMembers.filter((c) => { if (c.contact) return c })
          this.$events.$emit('research_group:updated', 'contacts', contacts)
          this.success = `Contact for ${this.getFullName(member)} is successfully updated`
          this.members = updatedMembers
          this.isRequest = false
        }).catch(err => {
          this.isRequest = false
          this.error = this.handleError(err)
        })
      }
    },
    destroyed () {
      this.$events.$off('research_group:permissions:updated')
      this.$events.$off('pusher:research_group-user-left')
      this.$events.$off('pusher:research_group-role-changed')
      this.$events.$off('pusher:research_group-contact-changed')
    }
  }
}
</script>
